import {
  AUTOMATED_USER_AGENT_PATTERN,
  hasAutomatedServerTiming,
  type TrafficClass,
} from "@shared/analytics/traffic-class";
import { readDocumentServerTiming } from "@/lib/telemetry/document-server-timing";

export interface TrafficSignals {
  webdriver: boolean;
  userAgent: string;
  vendor: string;
  edgeAutomated: boolean;
}

export function classifyTraffic(signals: TrafficSignals): TrafficClass {
  const automated =
    signals.webdriver ||
    signals.edgeAutomated ||
    AUTOMATED_USER_AGENT_PATTERN.test(signals.userAgent) ||
    AUTOMATED_USER_AGENT_PATTERN.test(signals.vendor);
  return automated ? "automated" : "human";
}

export function currentTrafficClass(): TrafficClass {
  if (typeof navigator === "undefined") return "human";
  return classifyTraffic({
    webdriver: navigator.webdriver === true,
    userAgent: navigator.userAgent,
    vendor: navigator.vendor,
    edgeAutomated: hasAutomatedServerTiming(readDocumentServerTiming()),
  });
}
